import React, { useState } from "react";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Use_Of_Alternative_Instrument_Filter from "./use_of_alternative_instrument_filter/Use_Of_Alternative_Instrument_Filter";
import Use_Of_Alternative_Instrument_Table from "./use_of_alternative_instrument_table/Use_Of_Alternative_Instrument_Table";

const Use_Of_Alternative_Instrument = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
    

      <div className="Sample_Report_Filter_div">
        <Use_Of_Alternative_Instrument_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <Use_Of_Alternative_Instrument_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Measurement Uncertainty Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Use_Of_Alternative_Instrument;
